import React from 'react';
import useBrowserInfo from '../hooks/useBrowserInfo';

const BrowserInfo = () => {
  const browserInfo = useBrowserInfo();

  return (
    <div>
      <h2>Browser Information</h2>
      <p><strong>App Name:</strong> {browserInfo.appName}</p>
      <p><strong>App Version:</strong> {browserInfo.appVersion}</p>
      <p><strong>User Agent:</strong> {browserInfo.userAgent}</p>
      <p><strong>Platform:</strong> {browserInfo.platform}</p>
    </div>
  );
};

export default BrowserInfo;